<template>
  <div :class="video_popup_class" @click="click_close_popup">
    <div
      v-if="show_instructions"
      class="dummy text-md py-2 mt-8 mb-auto inline-block"
    >
      &nbsp;
    </div>
    <div
      class="popup_video_container relative"
      v-if="is_video_src"
      @click="prevent_close($event)"
    >
      <div class="option-bar" v-if="is_closable" @click="click_close_popup">
        <span class="close-link">X</span>
      </div>
      <div class="mx-auto loading-app">
        <img src="../../assets/loading.svg" class="mx-auto w-32 inline-block" />
      </div>
      <video-player
        :options="playerOptions"
        :playsinline="true"
        @loadeddata="video_started"
        @ended="on_video_ended($event)"
      />
      <!--          <video :src="video_src" @loadeddata="video_started" @ended="close_popup" autoplay controls muted></video>-->
    </div>

    <div
      v-if="show_instructions"
      class="app-popup-instructions text-gray-100 text-sm px-12 py-2 text-md w-18 rounded-full inline-block mb-8 bg-black self-center mt-auto"
    >
      <span>The video will close automatically when it finishes playing.</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "VideoPopup",
  data() {
    return {
      loading: "loading"
    };
  },
  computed: {
    ...mapState(["current_section"]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),
    page_url() {
      var str = "/" + this.eventTag;
      if (this.$store.state.app_type == "mobile") {
        str += "/mobile";
      }
      str +=
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("&amp;")
          .join("and")
          .split("<br>")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/video/";
      return str;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    is_video_src() {
      return undefined != typeof this.$store.state.current_section;
    },
    video_src() {
      return "static/content/" + this.current_section + "/1.mp4";
    },
    video_popup_class() {
      return "popup " + this.loading;
    },
    playerOptions() {
      return {
        sources: [
          {
            type: "video/mp4",
            src: this.video_src
          }
        ]
      };
    },
    selected_section_name() {
      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    }
  },
  methods: {
    on_video_ended(e) {
      this.close_popup(e);

      this.$ga.event(this.eventTag + "-video_events", "end", this.page_url, 1);
    },
    click_close_popup(e) {
      if (this.is_closable) {
        e.preventDefault();
        this.close_popup(e);
      }
    },
    close_popup(e) {
      //if(e)
      //e.preventDefault();

      //there's a difference between the number of the transition
      //and what unity's animator is expecting for its param.
      //so unity is always one number ahead
      //quick fix is to send transition number minus one, but let's do better next time\
      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_unity_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_video_src, 10)
        );
      } else {
        if (
          this.$store.state.ambience_previous_vol >= 0 &&
          this.$store.state.ambience_previous_vol !=
            this.$store.state.ambience_current_vol
        ) {
          this.$bus.$emit(
            "on-request-ambience-fade",
            this.$store.state.ambience_previous_vol
          );
        }
      }
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    },
    video_started() {
      this.loading = "";

      this.$ga.event(
        this.eventTag + "-video_events",
        "start",
        this.page_url,
        1
      );
    }
  },
  mounted() {
    console.log("creating video popup");
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$bus.$emit("on-video-open");

    this.$store.dispatch("set_simple_val", {
      name: "ambience_previous_vol",
      val: this.$store.state.ambience_current_vol
    });
    this.$bus.$emit("on-request-ambience-fade", 0);

    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    console.log("destroying video popup");
    this.$bus.$off("on-request-video-close", this.close_popup);

    if (
      this.$store.state.ambience_previous_vol >= 0 &&
      this.$store.state.ambience_previous_vol !=
        this.$store.state.ambience_current_vol
    ) {
      this.$bus.$emit(
        "on-request-ambience-fade",
        this.$store.state.ambience_previous_vol
      );
    }
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
}
.popup iframe {
  width: 95%;
  height: 90%;
  margin-top: 5%;
}

.option-bar {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 40px;
  height: 40px;
  z-index: 1999;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}
.popup_video_container {
  align-self: center;
  margin: auto 0;
}
.popup .loading-app {
  display: none;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
}
.popup.loading .loading-app {
  display: block;
}
.popup.loading .video-player {
  opacity: 0;
}
.popup_video_container .video-player {
  opacity: 1;
  transition: opacity 0.4s;
}

.app-popup-instructions {
  background: rgba(20, 20, 20, 0.8);
  text-transform: uppercase;
}

@media only screen and (max-width: 1110px) {
  .popup .option-bar {
    top: -50px;
    right: 0;
  }
}
@media only screen and (max-width: 1110px) and (max-height: 460px) {
  .popup .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
</style>
<style>
.popup_video_container {
  max-width: 90%;
  margin: 0 auto;
  xmax-height: 60vh;
}

.video-js .vjs-volume-panel {
  display: none !important;
}
.video-js .vjs-control-bar {
  display: flex !important;
  bottom: -3em !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.video-js {
  width: auto !important;
  height: auto !important;
}

.video-js video {
  width: auto !important;
  height: auto !important;
  max-width: 90vw;
  max-height: 60vh;
  position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/VideoPopup.vue